import styled from "@emotion/styled";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "src/assets/images/new_logo_white.svg";
import { i18n, mediaQuery, openContactModal, useAppDispatch } from "src/common";
import { FIXED_HEADER_DOM_ID } from "src/common/hooks/useFixedHeaderOffsetPx.hook";
import config from "src/config";
import { colors, giveawayBanner, header } from "src/theme";
import { Flex } from "../grid";
import { ProgressBar } from "../other/progressBar.other";
import { Text } from "../typography/text.typography";
import { HeaderData } from "./headerData.layout";

const HeaderStyle = styled.div({
  backgroundColor: colors.primary,
  position: 'fixed',
  width: '100%',
  top: `${giveawayBanner.mobileHeight}px`,
  left: 0,
  zIndex: 100,

  [mediaQuery('laptopL')]: {
    top: `${giveawayBanner.height}px`,
  },
})

const LinkStyle = styled.a({
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.6
  },
})

const LogoStyle = styled.img({
  height: '24px'
})

const TextStyle = styled(Text)({
  color: colors.white
})

const ContainerStyle = styled(Flex)({
  height: `${header.mobileHeight}px`,
  padding: '24px',
  maxWidth: '100%',
  boxSizing: 'border-box',

  [mediaQuery('laptopL')]: {
    width: '1150px',
    maxWidth: '100%',
    margin: '0 auto',
    padding: 0,
    height: `${header.height}px`,
  },
})

interface HeaderProps {
  expanded: boolean;
  handleStyleExpansion: (value: boolean) => void;
  onHeaderDataVisibilityChange?: (visible: boolean) => void;
}
export const Header = ({ expanded, handleStyleExpansion }: HeaderProps) => {
  const dispatch = useAppDispatch();
  const [headerDataVisible, setHeaderDataVisible] = useState<boolean>(false);
  const { pathname } = useLocation();
  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };

  if (pathname.includes('print-health-questionnaire')) {
    return null;
  }

  if (pathname.includes('agent-edit-health-questionnaire')) {
    return null;
  }
  
  return (
    <HeaderStyle id={FIXED_HEADER_DOM_ID}>
      {/* <HeaderWidgetGiveaway /> */}
      <ContainerStyle justify='space-between' align='center' gap={8}>
        <LinkStyle onClick={navigateToHome}><LogoStyle src={logo} alt="" /></LinkStyle>
        <LinkStyle onClick={() => dispatch(openContactModal())}>
          <TextStyle type="base" bold>{i18n.t('layout.header.requestAgent')}</TextStyle>
        </LinkStyle>
      </ContainerStyle>
      <ProgressBar headerDataVisible={headerDataVisible} />
      <HeaderData
        expanded={expanded}
        handleStyleExpansion={handleStyleExpansion}
        onVisibilityChange={setHeaderDataVisible}
      />
    </HeaderStyle>
  )
};
